import { Container, CircularProgress } from "@mui/material";
import ItemList from "../../components/ItemList";
import { useState, useEffect } from "react";
import { getBackend } from "../../api/backend";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";


const Statuses = () => {

  const fieldsConfig = [
    { key: "uuid", label: "Placeholder", type: "text", displayForm: false, displayList: false },
    { key: "status", label: "Estado", type: "text", required: true, displayForm: true, displayList: true },
    { key: "color", label: "Color", type: "color-picker", required: true, displayForm: true, displayList: true }
  ];

  return (
    <Container maxWidth={false} disableGutters>
      <Box sx={{ display: "flex", justifyContent: "flex-start", marginBottom: "3%" }}>
        <Typography variant="h5" noWrap component="div"> 
          Estados
        </Typography>
      </Box>
      <ItemList fields={fieldsConfig} tableName="statuses" hasCheckbox={true} objectName={"status"} tabledescription={"Estados"}/>
    </Container>
  );
};

export default Statuses;